
import {Injectable} from '@angular/core';
import {RequestHandler} from '../OffService/request-handler';
import {SyncService} from '../OffService/sync.service';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';

@Injectable({
    providedIn: 'root'
})
export class CostesProductosApiService {

    public costesProductos = {
        GET: new RequestHandler(),
    };    

    constructor(private syncService: SyncService,
        private api: ApiRequestService) {

        this.defineCostesProductos();
    }

    private defineCostesProductos() {
        this.costesProductos.GET.fetch(HttpRequestType.GET, 'costes/costes_productos_get');

        this.api.registerRequest(this.costesProductos.GET);

        this.syncService.register(this.syncService.baseSyncPolicy(this.costesProductos.GET));
       
    }
}
